<script setup lang="ts">
onMounted(() => document.body.style.overflow = 'hidden')

onBeforeUnmount(() => document.body.style.overflow = '')
</script>

<template>
  <div class="fixed inset-0 z100 hfull wfull flex items-center justify-center bg-slate-900/25 backdrop-blur">
    <div class="flex items-center justify-center rounded-xl bg-white px6 py6 shadow-xl ring-1 ring-black/5">
      <svg
        class="h8 w8 animate-spin text-black"
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      >
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
        <path
          class="opacity-75" fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
  </div>
</template>
